import {
  SR_API_ACTION_CONFIRM_PHONE,
} from 'api/actionTypes';

import analytics from 'client/analytics';
import { ANALYTICS_EVENT_USER_PHONE_CONFIRMED } from 'client/analytics/eventList';

export default async function confirmPhone({ state, apiClient }, { phone }) {
  const phoneIsDifferent = phone !== state.get(['currentUser', 'phone']);
  await apiClient.postWithState({
    action: SR_API_ACTION_CONFIRM_PHONE,
    state: state,
    payload: {
      phone,
    },
    onSuccess() {
      state.set(['currentUser', 'phone'], phone);
      state.set(['currentUser', 'phoneConfirmed'], true);
    },
  });
  analytics.track(ANALYTICS_EVENT_USER_PHONE_CONFIRMED, {
    phoneChanged: phoneIsDifferent,
  });
}
